import React, { ReactNode } from 'react'
import { Button, Result } from 'antd'

import Catch from './сatch'

type Props = {
  children: ReactNode
}

const MyErrorBoundary = Catch(({ children }: Props, error?: Error) => {
  if (error) {
    return (
      <Result
        status="500"
        title="500"
        subTitle="Извините, что то пошло не так."
        extra={
          <Button type="link" href="/">
            Вернуться на главную.
          </Button>
        }
      />
    )
  }
  return children
})

export default MyErrorBoundary
